<template>
    <div class="main">
        <el-button v-on:click="backHistory" style="margin-button:2px;">返回</el-button>

        <el-collapse >
            <!-- <el-collapse-item :title="用户管理" :name="userData"> -->
                <el-row class="div">
                    <el-col :span="12" style="height:60px;margin-buttom:2%;"> 
                        <span class="detail-label" style=" line-height:50px;">用户头像：</span>
                        <img v-if="userData.is_examine == 2" class="detail-image" style="width: 50px;height: 50px;" :src="userData.image"> 
                        <img v-else class="detail-image" style="width: 50px;height: 50px;" :src="userData.ex_image"> 
                    </el-col>
                    <el-col :span="10"> <span class="detail-label">ID:</span><span>{{ userData.user_id}}</span> </el-col>
                </el-row>
                <el-row class="div">
                    <el-col v-if="userData.is_examine == 2"  :span="12"> <span class="detail-label">昵称;</span><span>{{ userData.nick}}</span> </el-col>
                    <el-col v-else :span="12"> <span class="detail-label">昵称;</span><span>{{ userData.ex_nick}}</span> </el-col>
                    <el-col :span="12"> <span class="detail-label">注册时间：</span><span>{{ userData.create_time}}</span> </el-col>
                </el-row>
                <el-row class="div">
                    <el-col :span="12"> <span class="detail-label">电话：</span><span>{{ userData.mobile}}</span> </el-col>
                    <el-col :span="12"> <span class="detail-label">角色：</span><span>{{ userData.is_rule | statusTypeFilterName }}</span> 
                    <el-button class="btn" type="text" @click="isPro(userData.user_id)" >更改</el-button>    
                </el-col>
                </el-row>
                <el-row class="div">
                    <el-col :span="12"> <span class="detail-label">分类：</span><span>{{ userData.type | statusType}}</span> </el-col>
                    <el-col :span="12"> <span class="detail-label">状态：</span><span>{{ userData.is_examine | statusExamine}}</span> 
                    <el-button class="btn" type="text" @click="toExamine(userData.user_id)" >更改</el-button>    
                </el-col>
                </el-row>
                <el-row class="div">
                    <el-col :span="12"> <span class="detail-label">关注数：</span><span>{{ userData.follow_num}}</span> </el-col>
                    <el-col :span="12"> <span class="detail-label">粉丝数：</span><span>{{ userData.fans_num}}</span> </el-col>
                </el-row>
                <el-row class="div">
                    <el-col :span="12"> <span class="detail-label">Plus：</span><span>{{ userData.plus_num}}</span> </el-col>
                </el-row>
                <el-row class="div">
                    <el-col :span="24"> <span class="detail-label">简介：</span><span>{{ userData.autograph }}</span> </el-col>
                </el-row>
        </el-collapse>
        <el-dialog
            :title="formName"
            :visible.sync="formVisible"
            :before-close="hideForm"
            v-loading="dialogLoading"
            width="23%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm" style="80px;">
                <el-radio-group v-model="formData.is_pro">
                    <el-radio :label="1">普通</el-radio>
                    <el-radio :label="2">认证</el-radio>
                    <el-radio :label='3'>Pro</el-radio>
                </el-radio-group>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button  type="primary" @click.native="formSubmit()" >提交</el-button>
                <!-- <el-button v-else type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button> -->
            </div>
        </el-dialog>
         <el-dialog
            :title="formNameExamine"
            :visible.sync="formVisibleExamine"
            :before-close="hideFormExamine"
            v-loading="dialogLoading"
            width="20%"
            top="5vh">
            <el-form :model="formDataExamine" :rules="formRules" ref="dataFormExamine">
                <el-radio-group v-model="formDataExamine.is_examine">
                    <el-radio :label="2">通过</el-radio>
                    <el-radio :label='3'>不通过</el-radio>
                </el-radio-group>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormExamine">取消</el-button>
                <el-button  type="primary" @click.native="formSubmitExamine()" >提交</el-button>
                <!-- <el-button v-else type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>
<script>

import {
    userInfo, userSave, userSaveExamine, userExmineChange
} from "../../../api/app-users/user";

export default {
    data() {
        return {
            userData:[],
            formVisible: false,
            formData: {
                user_id: '',
                is_pro: '',
            },
            formLoading:false,
            dialogLoading: false,
            formName: '设定',
            formNameExamine:'审核',
            formRules: {},
            formVisibleExamine:false,
            formDataExamine: {
                user_id: '',
                is_examine: '',
            },
        };
    },
    filters: {
        gender: function (value) {
            value = parseInt(value)
            if (value === 1) {
                return '男';
            }
            if (value === 0) {
                return '女';
            }
            return '未设置';
            // return parseInt(value)? '' :;
        },
        statusExamine(status) {
            const statusTypeMap = {
                1: "未审核",
                2: "审核通过",
                3: "审核未通过",
            };
            return statusTypeMap[status];
        },
        statusType(status) {
            const statusTypeMap = {
                1: "仅读",
                2: "可写",
            };
            return statusTypeMap[status];
        },
        statusTypeFilterName(status) {
            const statusTypeMap = {
                1: "普通",
                2: "认证",
                3: "Pro"
            };
            return statusTypeMap[status];
        },
    },
    methods: {
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        getUser() {
            userInfo({
                user_id: this.$route.params.id
            }).then(response => {
                if (parseInt(response.code) === 0) {
                    this.userData = response.data ? response.data : [];
                    console.log(this.userData,'this.userData');
                } else {
                    // this.$message.error(response.message);
                    // this.$router.push({ path: '/userManage/customerManage/normalUsers' });
                }
            }).catch(error => {
                    // this.$message.error(error.message);
                    // this.$router.push({ path: '/userManage/customerManage/normalUsers' });
            });
        },
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        hideFormExamine() {
            // 更改值
            this.formVisibleExamine = !this.formVisibleExamine;
            // 清空表单s
            this.$refs["dataFormExamine"].resetFields();
            return true;
        },
        // 更改 角色 Pro
        isPro(userid) {
            this.formData.user_id = userid;
            this.formVisible = true;
        },
        // 更改 角色 Pro 提交
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    userSave(this.formData).then(response => {
                        this.formLoading = false;
                        if (response.code !== 0) {
                            this.$message({ message: response.message, type: "error" });
                        } else {
                            this.$message.success("操作成功");
                            this.formVisible = false;
                            this.getUser();
                            // this.initUsers();
                            // this.$message({ message: "操作成功", type: "success" });
                            // windows.reload()
                            // this.$refs["dataForm"].resetFields();
                            // this.formVisible = false;
                            // this.getUser();
                        }
                    });
                }
            });
        },
        // 审核
        toExamine(userid) {
            this.formDataExamine.user_id = userid;
            console.log(this.formDataExamine,'this.formData111111111111');
            this.formVisibleExamine = true;
        },
        // 审核提交
        formSubmitExamine() {
            this.$refs["dataFormExamine"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    userExmineChange(this.formDataExamine).then(response => {
                        this.formLoading = false;
                        // console.log(response,'3344453454315')
                        if (response.code !== 0){
                            this.$message({ message: response.msg, type: "error" });
                        } else {
                            this.$message.success("操作成功");
                            this.formVisibleExamine = false;
                            this.getUser();
                        }
                    });
                }
            });
        },
    },
    
    mounted() {
        this.getUser();
    }
};
</script>
<style scoped>
    .details-line{
        min-height: 80px;
        line-height: 80px;
    }
    .div{
        height: 60px;
        border-bottom: 0.1px solid #BDBDBE;
        line-height: 60px;
    }
    .btn{
        margin-left: 20px;
    }
</style>
